import { useInjection } from 'libs/uikit/ioc/React';
import { ArrowRightIcon, Button, Callout, Flex, Text, Title, breakpointsMixin, useEvent } from 'libs/uikit/lib';
import { colors } from 'libs/uikit/lib/Color/Colors';
import { ExternalLink } from 'libs/uikit/lib/ExternalLink/ExternalLink';
import { useBreakpoints } from 'libs/uikit/lib/Hooks/useBreakpoints';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { css, styled } from 'styled-components';
import { IUserDirector } from '../../core/Abstractions/IUserDirector';
import { LoginForm } from './LoginForm';

const maxWidth = 592;

export function LoginPage() {
  const userDirector = useInjection(IUserDirector);

  const [params] = useSearchParams();

  const onLogin = useEvent(() => {
    const returnUrl = params.get('returnUrl');
    if (returnUrl && !returnUrl.includes('/login')) {
      try {
        window.location.assign(returnUrl);
      } catch {
        // if the return url parameter is broken somehow (maybe a user edited a link)
        // then just fallthrough to route based on the user's role
      }
    }

    window.location.assign(userDirector.getLandingPagePath());
  });

  return (
    <StyledPageLayout>
      <Flex justify="center" horizontal>
        <Flex gap={3} justify="center" align="stretch" alignSelf="center" padding={2} flex={1} style={{ maxWidth }}>
          <img width={275} height={64} src={require('../Assets/logo.svg')} />

          <Flex gap={2} align="stretch">
            <Title size="h1" bold>
              Log in
            </Title>
            <LoginForm onSuccess={onLogin} />
          </Flex>

          <Callout intent="secondary">
            <Flex
              gap={1}
              justify="space-between"
              align="center"
              horizontal={{
                xs: false,
                lg: true,
              }}
            >
              <Text bold scale={-1}>
                Don't have an EventsPass account?
              </Text>
              <ExternalLink href="https://www.eventspass.co/contact-us/" noUnderline noIcon>
                <Button variant="outlined" light scale={0}>
                  Contact us
                </Button>
              </ExternalLink>
            </Flex>
          </Callout>

          <Text scale={-2} muted style={{ textAlign: 'center' }}>
            EventsPass ·{' '}
            <ExternalLink
              href="https://www.eventspass.co/terms-and-conditions-event-organisers/"
              color={colors.blue_900}
              noIcon
            >
              Terms of use
            </ExternalLink>
          </Text>
        </Flex>
      </Flex>

      <Flex justify="center" horizontal style={{ position: 'relative' }}>
        <StyledBackground />
        <Flex gap={2} padding={2} alignSelf="center" style={{ maxWidth }}>
          <Title size="h1" style={{ color: 'white' }}>
            Discover how EventsPass quickly launches ticketing and registration for event organizers worldwide.
          </Title>
          <ExternalLink href="https://www.eventspass.co/" noUnderline noIcon>
            <Button success scale={2} iconRight={ArrowRightIcon}>
              Learn more
            </Button>
          </ExternalLink>
        </Flex>
      </Flex>
    </StyledPageLayout>
  );
}

const StyledPageLayout = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;

  ${breakpointsMixin(
    {
      xs: 'row',
      lg: 'column',
    },
    (value) =>
      css`
        grid-auto-flow: ${value};
      `
  )}
`;

const StyledBanner = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`;

const StyledBrightnessGradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to top, rgb(0, 0, 0), rgb(156, 163, 175));
  mix-blend-mode: multiply;
  opacity: 0.8;
  z-index: -1;
`;

function StyledBackground() {
  return (
    <>
      <StyledBanner src={require('./Assets/banner.jpg')} />
      <StyledBrightnessGradient />
    </>
  );
}
